import { awsAPIConfigFactory } from 'src/apis/configs/awsConfig';
import { ExpandValidityResponse } from './state';
import { configFile } from 'src/components/Retention/Retention.constants';

const urlRequest = `${process.env.REACT_APP_ADMINISTRATION_API_URL}expand_validity`;

const APIConfigs = awsAPIConfigFactory(process.env.REACT_APP_ADMINISTRATION_XAPIKEY);

export const getExpandValidity = async ({ token, page, selectedTab = configFile[0].tab, search }): Promise<ExpandValidityResponse> => {
    const url = `${urlRequest}`;

    let params = new URLSearchParams({ country: 'MX', page: page });
    if (selectedTab === configFile[1].tab) {
        params.append('retention_users', '1');
    }
    if (search) {
        params.append('search', search);
    }

    const res = await fetch(`${url}?${params}`, APIConfigs('GET', token));
    const response = await res.json();
    return response as ExpandValidityResponse;
};

export const updateExpandValidity = async ({ token, data }: { token: string; data: { user_id: number; ticket_id: number } }) => {
    const params = new URLSearchParams({ country: 'MX' });
    const newData = { country: 'MX', ...data };
    const res = await fetch(`${urlRequest}?${params}`, APIConfigs('PUT', token, newData));
    return res.json();
};
